import { PropsWithChildren, ChangeEventHandler } from "react";
import styles from "./Select.module.scss";

type SelectorProps = {
  id?: string;
  name?: string;
  dataTestId?: string;
  value?: string;
  ariaLabel?: string;
  onChange?: ChangeEventHandler<HTMLSelectElement>;
  ref?: React.RefObject<HTMLSelectElement | null>;
};

export const Select = ({
  id,
  name,
  dataTestId,
  value,
  ariaLabel,
  onChange = () => {},
  ref,
  children,
}: PropsWithChildren<SelectorProps>) => {
  return (
    <div data-testid="select-container" className={styles.container}>
      <select
        ref={ref}
        id={id}
        name={name}
        value={value}
        aria-label={ariaLabel}
        data-testid={dataTestId}
        onChange={onChange}
        className={styles.select}
      >
        {children}
      </select>
    </div>
  );
};
